import { makeObservable, observable, flow, computed } from "mobx";
import { Add } from "@/components/icons/IconMap";
import { ApiRoutes } from "@/lib/routes";
import { api } from "@/lib/services";

import BrowseAuditsSchema from "@/areas/compliance/schemas/BrowseAuditsSchema";
import { ComplianceConstants } from "./ComplianceConstants";

export default class BrowseAuditsStore {
  loading = true;
  pagination = null;
  audits = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      pagination: observable,
      audits: observable,
      actions: computed,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  get actions() {
    const list = [];

    list.push({
      id: "audit:addAudit",
      label: "New Audit",
      onClick: () => this.parentStore.createAuditStore.show(),
      icon: Add,
      location: "primary",
      processing: this.parentStore.createAuditStore.processing,
      disabled: this.processing || !this.parentStore.createAuditStore.canCreate,
    });

    return list;
  }

  consume(audit) {
    const index = this.audits.findIndex((e) => e.id === audit.id);
    if (index !== -1) {
      this.audits.splice(index, 1, audit);
      this.audits = [...this.audits];
    }
  }
  *load(query, options) {
    const parseResult = BrowseAuditsSchema.safeParse(query);
    if (!parseResult.success) {
      console.error(parseResult.error);

      return parseResult;
    }

    try {
      this.loading = true;

      const existingQuery = query.query;
      const storedRegistry = JSON.parse(localStorage.getItem(ComplianceConstants.StateKeys.AuditRegistries)) ?? [];
      const storedRegistryIds = storedRegistry.map((x) => x.id);
      const updatedQuery = { ...existingQuery, auditRegistry: { id: storedRegistryIds } };

      const response = yield api.post(ApiRoutes.forAuditSearch(), { ...query, query: updatedQuery });

      this.audits = response.data.items;
      this.pagination = {
        page: response.data.page,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        pageSize: response.data.pageSize,
      };

      return { success: true, data: response.data };
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
